The identifier for the unposted `PositionProfile` to update.
